/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    // Закриття при кліку поза випадаючим меню на десктопі
    if (window.innerWidth >= 768) {
      this.outsideClickHandler = (evt) => {
        if (this.hasAttribute('open') && !this.contains(evt.target) && !evt.target.closest('.cart-link')) {
          this.close();
        }
      };
      document.addEventListener('click', this.outsideClickHandler);
    }
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    if (this.outsideClickHandler) {
      document.removeEventListener('click', this.outsideClickHandler);
    }
  }

  /**
   * Override open method to redirect to cart page on mobile or position dropdown on desktop
   * @param {Element} opener - Element that triggered opening of the drawer.
   * @param {Element} elementToFocus - Element to focus after drawer opened.
   * @param {Function} callback - Callback function to trigger after the open has completed
   */
  open(opener, elementToFocus, callback) {
    // На мобільних пристроях перенаправляємо на сторінку корзини
    if (window.innerWidth < 768) {
      window.location.href = '/cart';
      return;
    }
    
    // Зберігаємо поточну позицію скролу перед відкриттям
    const currentScrollY = window.scrollY;
    
    // На десктопі позиціонуємо випадаюче меню під іконкою корзини
    this.positionDropdown(opener);
    
    // Викликаємо батьківський метод, але потім перевизначаємо поведінку для десктопу
    super.open(opener, elementToFocus, callback);
    
    // На десктопі не блокуємо скрол і не показуємо overlay
    if (window.innerWidth >= 768) {
      // Відновлюємо позицію скролу перед видаленням fixed
      window.scrollTo(0, currentScrollY);
      document.body.classList.remove('fixed');
      document.body.style.top = '';
      document.documentElement.style.height = '';
      if (this.overlay) {
        this.overlay.classList.remove('is-visible');
      }
      // Переконуємося, що позиція скролу залишилася незмінною
      requestAnimationFrame(() => {
        window.scrollTo(0, currentScrollY);
      });
    }
  }

  /**
   * Позиціонує випадаюче меню в правому верхньому куті
   * @param {Element} opener - Element that triggered opening (cart-link)
   */
  positionDropdown(opener) {
    // Позиціонуємо випадаюче меню в правому верхньому куті, заходить на header
    // inset: top right bottom left
    this.style.inset = `-10px 0px auto auto`;
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);
